import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class IconsAsignaturasService {
    private _sanitizer = inject(DomSanitizer)

    // Iconos de asignaturas de primaria
    public pri_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_def.svg');
    public pri_atlas = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_atl.svg');
    public pri_exploracion_mundo_natural = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_nat.svg');
    public pri_pensamiento_critico_solucion_problemas = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_pec.svg');
    public pri_expresion_artistica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_art.svg');
    public pri_educacion_fisica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_efi.svg');
    public pri_convivencia_ciudadania = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_cyc.svg');
    public pri_geografia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_geo.svg');
    public pri_historia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_his.svg');
    public pri_lecturas_comprension = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_lec.svg');
    public pri_lenguaje_comunicacion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_lyc.svg');
    public pri_pensamiento_matematico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pri/d_asig_pri_mat.svg');

    // Iconos de asignaturas de preescolar
    public pre_desarrollo_fisico_salud = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pre/d_asig_pre_dfs.svg');
    public pre_desarrollo_personal_social = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pre/d_asig_pre_dep.svg');
    public pre_exploracion_conocimiento_mundo = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pre/d_asig_pre_exc.svg');
    public pre_expresion_artistica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pre/d_asig_pre_exa.svg');
    public pre_lenguaje_comunicacion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pre/d_asig_pre_len.svg');
    public pre_pensamiento_matematico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/pre/d_asig_pre_mat.svg');

    // Iconos de asignaturas de secundaria
    public sec_biologia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_bio.svg');
    public sec_expresion_artistica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_exa.svg');
    public sec_convivencia_ciudadania = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_cyc.svg');
    public sec_fisica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_fis.svg');
    public sec_geografia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_geo.svg');
    public sec_historia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_his.svg');
    public sec_habilidades_digitales = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_dig.svg');
    public sec_lenguaje_comunicacion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_lyc.svg');
    public sec_pensamiento_matematico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_mat.svg');
    public sec_quimica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/sec/d_asig_sec_qmc.svg');

    // Iconos de asignaturas de bachillerato
    public bac_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_def.svg');
    public bac_biologia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_bio.svg');
    public bac_ciencias_comunicacion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_com.svg');
    public bac_ciencias_salud = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_csa.svg');
    public bac_ciencias_sociales = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_cso.svg');
    public bac_derecho = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_der.svg');
    public bac_desarrollo_comunitario = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_dco.svg');
    public bac_ecologia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_eco.svg');
    public bac_educacion_artistica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_eda.svg');
    public bac_estructura_socioeconomica_mexico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_esm.svg');
    public bac_filosofia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_fil.svg');
    public bac_fisica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_fis.svg');
    public bac_geografia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_geo.svg');
    public bac_historia_mexico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_hmx.svg');
    public bac_historia_universal_contemporanea = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_hun.svg');
    public bac_literatura = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_lit.svg');
    public bac_matematicas = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_mat.svg');
    public bac_metodologia_investigacion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_met.svg');
    public bac_tecnologia = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_tec.svg');
    public bac_probabilidad_estadistica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_est.svg');
    public bac_quimica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_qmc.svg');
    public bac_taller_lectura_redaccion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_tlr.svg');
    public bac_etica_valores = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/bac/d_asig_bac_eyv.svg');

    // Iconos de tecnología/informática
    public inf_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_df.svg');
    public inf_excel = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_exc.svg');
    public inf_powerpoint = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ppo.svg');
    public inf_word = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_wod.svg');
    public inf_nivel1 = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ti1.svg');
    public inf_nivel2 = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ti2.svg');
    public inf_nivel3 = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ti3.svg');
    public inf_nivel4 = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ti4.svg');
    public inf_nivel5 = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ti5.svg');
    public inf_nivel6 = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/inf/d_asig_inf_ti6.svg');

    // Iconos de lecturas
    public lec_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/lec/d_asig_lec_def.svg');
    public lec_lenguaje_comunicacion = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/lec/d_asig_lec_lyc.svg');
    public lec_lecturas_comprension = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/lec/d_asig_lec_lec.svg');

    // Iconos de CRK (Robótica)
    public crk_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/crk/d_asig_crk_def.svg');
    public crk_robotica = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/crk/d_asig_crk_crk.svg');

    // Iconos de Habilidades
    public hab_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/hab/d_asig_hab_def.svg');
    public hab_basicas_pensamiento = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/hab/d_asig_hab_bpe.svg');
    public hab_razonamiento_verbal = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/hab/d_asig_hab_rve.svg');
    public hab_razonamiento_matematico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/hab/d_asig_hab_rma.svg');
    public hab_razonamiento_logico = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/hab/d_asig_hab_rlo.svg');

    // Iconos de Ciencia para Niños
    public cie_default = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_def.webp');
    public cie_cuerpo_humano = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_cue.webp');
    public cie_naturaleza_tierra = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_nat.webp');
    public cie_espacio_universo = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_esp.webp');
    public cie_a_volar = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_vol.webp');
    public cie_sobre_ruedas = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_sob.webp');
    public cie_sonidos_electricidad = this._sanitizer.bypassSecurityTrustResourceUrl('assets/redi/icons/asignaturas/cie/d_asig_cie_son.webp');

    constructor() {
        console.debug('IconsAsignaturasService initialized with primary, preschool, secondary and bachillerato subject icons');
    }

    /**
     * @description Obtiene el icono de una asignatura por su identificador CSS
     * @param cssId Identificador CSS de la asignatura (ej: 'd_asig_pri_mat', 'd_asig_pre_dfs', 'd_asig_sec_bio', etc.)
     * @returns SafeResourceUrl del icono correspondiente
     */
    public getIconByCssId(cssId: string) {
        const iconMap: { [key: string]: any } = {
            // Iconos de primaria
            'd_asig_pri_def': this.pri_default,
            'd_asig_pri_atl': this.pri_atlas,
            'd_asig_pri_nat': this.pri_exploracion_mundo_natural,
            'd_asig_pri_pec': this.pri_pensamiento_critico_solucion_problemas,
            'd_asig_pri_exa': this.pri_expresion_artistica,
            'd_asig_pri_efi': this.pri_educacion_fisica,
            'd_asig_pri_cyc': this.pri_convivencia_ciudadania,
            'd_asig_pri_geo': this.pri_geografia,
            'd_asig_pri_his': this.pri_historia,
            'd_asig_pri_lec': this.pri_lecturas_comprension,
            'd_asig_pri_lyc': this.pri_lenguaje_comunicacion,
            'd_asig_pri_mat': this.pri_pensamiento_matematico,

            // Iconos de preescolar
            'd_asig_pre_dfs': this.pre_desarrollo_fisico_salud,
            'd_asig_pre_dep': this.pre_desarrollo_personal_social,
            'd_asig_pre_exc': this.pre_exploracion_conocimiento_mundo,
            'd_asig_pre_exa': this.pre_expresion_artistica,
            'd_asig_pre_len': this.pre_lenguaje_comunicacion,
            'd_asig_pre_mat': this.pre_pensamiento_matematico,

            // Iconos de secundaria
            'd_asig_sec_bio': this.sec_biologia,
            'd_asig_sec_exa': this.sec_expresion_artistica,
            'd_asig_sec_cyc': this.sec_convivencia_ciudadania,
            'd_asig_sec_fis': this.sec_fisica,
            'd_asig_sec_geo': this.sec_geografia,
            'd_asig_sec_his': this.sec_historia,
            'd_asig_sec_dig': this.sec_habilidades_digitales,
            'd_asig_sec_lyc': this.sec_lenguaje_comunicacion,
            'd_asig_sec_mat': this.sec_pensamiento_matematico,
            'd_asig_sec_qmc': this.sec_quimica,

            // Iconos de bachillerato
            'd_asig_bac_def': this.bac_default,
            'd_asig_bac_bio': this.bac_biologia,
            'd_asig_bac_com': this.bac_ciencias_comunicacion,
            'd_asig_bac_csa': this.bac_ciencias_salud,
            'd_asig_bac_cso': this.bac_ciencias_sociales,
            'd_asig_bac_der': this.bac_derecho,
            'd_asig_bac_dco': this.bac_desarrollo_comunitario,
            'd_asig_bac_eco': this.bac_ecologia,
            'd_asig_bac_eda': this.bac_educacion_artistica,
            'd_asig_bac_esm': this.bac_estructura_socioeconomica_mexico,
            'd_asig_bac_fil': this.bac_filosofia,
            'd_asig_bac_fis': this.bac_fisica,
            'd_asig_bac_geo': this.bac_geografia,
            'd_asig_bac_hmx': this.bac_historia_mexico,
            'd_asig_bac_hun': this.bac_historia_universal_contemporanea,
            'd_asig_bac_lit': this.bac_literatura,
            'd_asig_bac_mat': this.bac_matematicas,
            'd_asig_bac_met': this.bac_metodologia_investigacion,
            'd_asig_bac_tec': this.bac_tecnologia,
            'd_asig_bac_est': this.bac_probabilidad_estadistica,
            'd_asig_bac_qmc': this.bac_quimica,
            'd_asig_bac_tlr': this.bac_taller_lectura_redaccion,
            'd_asig_bac_eyv': this.bac_etica_valores,

            // Iconos de tecnología/informática
            'd_asig_inf_def': this.inf_default,
            'd_asig_inf_exc': this.inf_excel,
            'd_asig_inf_ppo': this.inf_powerpoint,
            'd_asig_inf_wod': this.inf_word,
            'd_asig_inf_ti1': this.inf_nivel1,
            'd_asig_inf_ti2': this.inf_nivel2,
            'd_asig_inf_ti3': this.inf_nivel3,
            'd_asig_inf_ti4': this.inf_nivel4,
            'd_asig_inf_ti5': this.inf_nivel5,
            'd_asig_inf_ti6': this.inf_nivel6,

            // Iconos de lecturas
            'd_asig_lec_def': this.lec_default,
            'd_asig_lec_lyc': this.lec_lenguaje_comunicacion,
            'd_asig_lec_lec': this.lec_lecturas_comprension,

            // Iconos de CRK (Robótica)
            'd_asig_crk_def': this.crk_default,
            'd_asig_crk_crk': this.crk_robotica,

            // Iconos de Habilidades
            'd_asig_hab_def': this.hab_default,
            'd_asig_hab_bpe': this.hab_basicas_pensamiento,
            'd_asig_hab_rve': this.hab_razonamiento_verbal,
            'd_asig_hab_rma': this.hab_razonamiento_matematico,
            'd_asig_hab_rlo': this.hab_razonamiento_logico,

            // Iconos de Ciencia para Niños
            'd_asig_cie_def': this.cie_default,
            'd_asig_cie_cue': this.cie_cuerpo_humano,
            'd_asig_cie_nat': this.cie_naturaleza_tierra,
            'd_asig_cie_esp': this.cie_espacio_universo,
            'd_asig_cie_vol': this.cie_a_volar,
            'd_asig_cie_sob': this.cie_sobre_ruedas,
            'd_asig_cie_son': this.cie_sonidos_electricidad
        };

        return iconMap[cssId] || this.pri_default;
    }



    /**
     * @description Obtiene todos los iconos disponibles de primaria
     * @returns Array con todos los iconos y sus identificadores de primaria
     */
    public getAllPrimaryIcons() {
        return [
            { id: 'd_asig_pri_def', name: 'Default', icon: this.pri_default },
            { id: 'd_asig_pri_atl', name: 'Atlas', icon: this.pri_atlas },
            { id: 'd_asig_pri_nat', name: 'Exploración del mundo natural', icon: this.pri_exploracion_mundo_natural },
            { id: 'd_asig_pri_pec', name: 'Pensamiento crítico y solución de problemas', icon: this.pri_pensamiento_critico_solucion_problemas },
            { id: 'd_asig_pri_exa', name: 'Expresión artística', icon: this.pri_expresion_artistica },
            { id: 'd_asig_pri_efi', name: 'Educación Física', icon: this.pri_educacion_fisica },
            { id: 'd_asig_pri_cyc', name: 'Convivencia y ciudadanía', icon: this.pri_convivencia_ciudadania },
            { id: 'd_asig_pri_geo', name: 'Geografía', icon: this.pri_geografia },
            { id: 'd_asig_pri_his', name: 'Historia', icon: this.pri_historia },
            { id: 'd_asig_pri_lec', name: 'Lecturas de comprensión', icon: this.pri_lecturas_comprension },
            { id: 'd_asig_pri_lyc', name: 'Lenguaje y comunicación', icon: this.pri_lenguaje_comunicacion },
            { id: 'd_asig_pri_mat', name: 'Pensamiento Matemático', icon: this.pri_pensamiento_matematico }
        ];
    }

    /**
     * @description Obtiene todos los iconos disponibles de preescolar
     * @returns Array con todos los iconos y sus identificadores de preescolar
     */
    public getAllPreschoolIcons() {
        return [
            { id: 'd_asig_pre_dfs', name: 'Desarrollo físico y salud', icon: this.pre_desarrollo_fisico_salud },
            { id: 'd_asig_pre_dep', name: 'Desarrollo personal y social', icon: this.pre_desarrollo_personal_social },
            { id: 'd_asig_pre_exc', name: 'Exploración y conocimiento del mundo', icon: this.pre_exploracion_conocimiento_mundo },
            { id: 'd_asig_pre_exa', name: 'Expresión Artística', icon: this.pre_expresion_artistica },
            { id: 'd_asig_pre_len', name: 'Lenguaje y comunicación', icon: this.pre_lenguaje_comunicacion },
            { id: 'd_asig_pre_mat', name: 'Pensamiento matemático', icon: this.pre_pensamiento_matematico }
        ];
    }

    /**
     * @description Obtiene todos los iconos disponibles de secundaria
     * @returns Array con todos los iconos y sus identificadores de secundaria
     */
    public getAllSecondaryIcons() {
        return [
            { id: 'd_asig_sec_bio', name: 'Biología', icon: this.sec_biologia },
            { id: 'd_asig_sec_exa', name: 'Expresión artística', icon: this.sec_expresion_artistica },
            { id: 'd_asig_sec_cyc', name: 'Convivencia y ciudadanía', icon: this.sec_convivencia_ciudadania },
            { id: 'd_asig_sec_fis', name: 'Física', icon: this.sec_fisica },
            { id: 'd_asig_sec_geo', name: 'Geografía', icon: this.sec_geografia },
            { id: 'd_asig_sec_his', name: 'Historia', icon: this.sec_historia },
            { id: 'd_asig_sec_dig', name: 'Habilidades digitales', icon: this.sec_habilidades_digitales },
            { id: 'd_asig_sec_lyc', name: 'Lenguaje y comunicación', icon: this.sec_lenguaje_comunicacion },
            { id: 'd_asig_sec_mat', name: 'Pensamiento Matemático', icon: this.sec_pensamiento_matematico },
            { id: 'd_asig_sec_qmc', name: 'Química', icon: this.sec_quimica }
        ];
    }

    /**
     * @description Obtiene todos los iconos disponibles de bachillerato
     * @returns Array con todos los iconos y sus identificadores de bachillerato
     */
    public getAllBachilleratoIcons() {
        return [
            { id: 'd_asig_bac_def', name: 'Default', icon: this.bac_default },
            { id: 'd_asig_bac_bio', name: 'Biología', icon: this.bac_biologia },
            { id: 'd_asig_bac_com', name: 'Ciencias de la comunicación', icon: this.bac_ciencias_comunicacion },
            { id: 'd_asig_bac_csa', name: 'Ciencias de la salud', icon: this.bac_ciencias_salud },
            { id: 'd_asig_bac_cso', name: 'Ciencias sociales', icon: this.bac_ciencias_sociales },
            { id: 'd_asig_bac_der', name: 'Derecho', icon: this.bac_derecho },
            { id: 'd_asig_bac_dco', name: 'Desarrollo comunitario', icon: this.bac_desarrollo_comunitario },
            { id: 'd_asig_bac_eco', name: 'Ecología', icon: this.bac_ecologia },
            { id: 'd_asig_bac_eda', name: 'Educación artística', icon: this.bac_educacion_artistica },
            { id: 'd_asig_bac_esm', name: 'Estructura socioeconómica de México', icon: this.bac_estructura_socioeconomica_mexico },
            { id: 'd_asig_bac_fil', name: 'Filosofía', icon: this.bac_filosofia },
            { id: 'd_asig_bac_fis', name: 'Física', icon: this.bac_fisica },
            { id: 'd_asig_bac_geo', name: 'Geografía', icon: this.bac_geografia },
            { id: 'd_asig_bac_hmx', name: 'Historia de México', icon: this.bac_historia_mexico },
            { id: 'd_asig_bac_hun', name: 'Historia universal contemporánea', icon: this.bac_historia_universal_contemporanea },
            { id: 'd_asig_bac_lit', name: 'Literatura', icon: this.bac_literatura },
            { id: 'd_asig_bac_mat', name: 'Matemáticas', icon: this.bac_matematicas },
            { id: 'd_asig_bac_met', name: 'Metodología de la investigación', icon: this.bac_metodologia_investigacion },
            { id: 'd_asig_bac_tec', name: 'Tecnología', icon: this.bac_tecnologia },
            { id: 'd_asig_bac_est', name: 'Probabilidad y estadística', icon: this.bac_probabilidad_estadistica },
            { id: 'd_asig_bac_qmc', name: 'Química', icon: this.bac_quimica },
            { id: 'd_asig_bac_tlr', name: 'Taller de lectura y redacción', icon: this.bac_taller_lectura_redaccion },
            { id: 'd_asig_bac_eyv', name: 'Ética y valores', icon: this.bac_etica_valores },

            // Iconos de tecnología/informática
            { id: 'd_asig_inf_def', name: 'Default', icon: this.inf_default },
            { id: 'd_asig_inf_exc', name: 'Excel', icon: this.inf_excel },
            { id: 'd_asig_inf_ppo', name: 'Power Point', icon: this.inf_powerpoint },
            { id: 'd_asig_inf_wod', name: 'Word', icon: this.inf_word },
            { id: 'd_asig_inf_ti1', name: 'nivel 1', icon: this.inf_nivel1 },
            { id: 'd_asig_inf_ti2', name: 'nivel 2', icon: this.inf_nivel2 },
            { id: 'd_asig_inf_ti3', name: 'nivel 3', icon: this.inf_nivel3 },
            { id: 'd_asig_inf_ti4', name: 'nivel 4', icon: this.inf_nivel4 },
            { id: 'd_asig_inf_ti5', name: 'nivel 5', icon: this.inf_nivel5 },
            { id: 'd_asig_inf_ti6', name: 'nivel 6', icon: this.inf_nivel6 },

            // Iconos de lecturas
            { id: 'd_asig_lec_def', name: 'Default', icon: this.lec_default },
            { id: 'd_asig_lec_lyc', name: 'Lenguaje y Comunicación', icon: this.lec_lenguaje_comunicacion },
            { id: 'd_asig_lec_lec', name: 'Lecturas de comprensión', icon: this.lec_lecturas_comprension },

            // Iconos de CRK (Robótica)
            { id: 'd_asig_crk_def', name: 'Default', icon: this.crk_default },
            { id: 'd_asig_crk_crk', name: 'Robótica', icon: this.crk_robotica },

            // Iconos de Habilidades
            { id: 'd_asig_hab_def', name: 'Default', icon: this.hab_default },
            { id: 'd_asig_hab_bpe', name: 'Básicas del Pensamiento', icon: this.hab_basicas_pensamiento },
            { id: 'd_asig_hab_rve', name: 'Razonamiento verbal', icon: this.hab_razonamiento_verbal },
            { id: 'd_asig_hab_rma', name: 'Razonamiento matemático', icon: this.hab_razonamiento_matematico },
            { id: 'd_asig_hab_rlo', name: 'Razonamiento lógico', icon: this.hab_razonamiento_logico },

            // Iconos de Ciencia para Niños
            { id: 'd_asig_cie_def', name: 'Default', icon: this.cie_default },
            { id: 'd_asig_cie_cue', name: 'Cuerpo humano', icon: this.cie_cuerpo_humano },
            { id: 'd_asig_cie_nat', name: 'Naturaleza, la tierra es nuestra', icon: this.cie_naturaleza_tierra },
            { id: 'd_asig_cie_esp', name: 'Espacio y universo', icon: this.cie_espacio_universo },
            { id: 'd_asig_cie_vol', name: 'A volar, todos a volar', icon: this.cie_a_volar },
            { id: 'd_asig_cie_sob', name: 'Sobre ruedas y máquinas', icon: this.cie_sobre_ruedas },
            { id: 'd_asig_cie_son', name: 'Sonidos y electricidad', icon: this.cie_sonidos_electricidad }
        ];
    }

    /**
     * @description Obtiene todos los iconos disponibles (primaria, preescolar, secundaria y bachillerato)
     * @returns Array con todos los iconos y sus identificadores
     */
    public getAllIcons() {
        return [
            ...this.getAllPrimaryIcons(),
            ...this.getAllPreschoolIcons(),
            ...this.getAllSecondaryIcons(),
            ...this.getAllBachilleratoIcons()
        ];
    }

    /**
     * @description Obtiene iconos por nivel educativo
     * @param nivel Nivel educativo ('primaria' | 'preescolar' | 'secundaria' | 'bachillerato')
     * @returns Array con los iconos del nivel especificado
     */
    public getIconsByLevel(nivel: 'primaria' | 'preescolar' | 'secundaria' | 'bachillerato') {
        switch (nivel) {
            case 'primaria':
                return this.getAllPrimaryIcons();
            case 'preescolar':
                return this.getAllPreschoolIcons();
            case 'secundaria':
                return this.getAllSecondaryIcons();
            case 'bachillerato':
                return this.getAllBachilleratoIcons();
            default:
                return this.getAllIcons();
        }
    }
}
